<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5>{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary btn-buscar" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <hr class="mt-1" />    
    <div class="row">


      <div class="col-12 form-group" id="seleccione_div">     
          <h6>Ingrese la siguiente entrada:</h6>
     </div>




        
    <div class="col-12 form-group" id="clave_del_codigo_qr_div">
          <h6>Clave del Codigo QR</h6>
          <input class="form-control" type="text" placeholder="Ingrese la clave del codigo QR" v-model="clave_del_codigo_qr" id="clave_del_codigo_qr"  />
    </div>

    <div class="d-flex" style="height: 100px;">
    <div class="vr"></div>
    </div>




    </div>
    
    <hr class="mt-1" />
    <div id="RealizarFiltrosBusqueda_div" class="d-flex row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7 pb-2 text-left">          
          <button class="btn btn-primary overwrapDeBotones p-2 btn-buscar" @click="limpiarFiltros();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>
      </div> 
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 mb-1 pb-1 text-right">


          <button type="button" v-if="camposLlenos()"  class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>


         



      </div> 
      
    </div>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import func from './Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    directives: {
        tooltipF
    },
    data() {
      return {
        enumeraciones,
        consecutivo: "",
        numeroExtra: '',  
        numeroCarpeta: null, 
        fechaInicial: moment().subtract(5, 'days').format('YYYY-MM-DD'),
        fechaFinal: moment().format('YYYY-MM-DD'),
        mostrarNumeroExtra: false,     
        
        
        parametros_TipoEstatus: {
          key: "",
          tipoEstatusFirmaId: 2,
          parametros: {},
          esInformativo: false
        },
        folioAcuerdo: null,
        nombre: null,
       
        apellido_paterno: null,
        apellido_materno: null,
        clave_del_procesado: null,
        clave_del_codigo_qr: null,
        TipoReporte: 0,
        titulosdelreporte: {
          1: 'Comprobante del recibo de firmas del:'
        }        
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C008TiposEstatusFirma: catalogos.SIVAC.C008TiposEstatusFirma,
    },
    props: {
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      ejecutaLaFuncion: Function,
      ejecutaLaFuncion2: Function,
      ejecutaLaFuncion3: Function,
      ejecutaLaFuncion4: Function,
      ejecutalimpiarTablaResultados: Function,
      filtrosEstablecidos: Object,
      buscar: true,
      accionCancelar: {
        default: null,
        type: Object
      },
      AccionesMostrar:{            
        firma: false,
        pagos: false          
      },
      area: null
    },
    mounted() {            
      // if(this.elementosAOmitir){
      //   if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
      //     this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
      //     this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
      //   }
      //   if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
      //     this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
      //     this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
      //   }
      // }          
      
      /*this.parametros_Area.parametros.SistemaId = 38;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true; */
    },
    beforeMount()
    {
      // if(this.area != undefined && this.area != null)
      // {
      //   this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Area.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Materia.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Area.parametros.conInactivos = true;
      // }
      // else{
      //   this.parametros_TipoDocumento.parametros.elementosAConservar = [1,2,10,16,23,24];
      // }

      // if(this.elementosAConservar){        
      //   if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
      //     this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
      //     this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
      //   }
      // }
    },
    created() {
      // this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);

      this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
      this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);          
    },
    methods: {

      eventoCambioTipoDeReporte: function() {

        this.$emit('emitGetTipoReporte', this.titulosdelreporte[parseInt(this.TipoReporte)]);
      },

      
      /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       */
      limpiarFiltros: function(){


        this.parametros_TipoEstatus.tipoEstatusFirmaId = 2;
        this.parametros_TipoEstatus.key += 1;

        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null;             
        this.numeroCarpeta = null; 
        
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null;
        this.clave_del_procesado= null;

        this.clave_del_codigo_qr= null;


        this.fechaInicial= moment().subtract(5, 'days').format('YYYY-MM-DD');
        this.fechaFinal= moment().format('YYYY-MM-DD');

        // this.fechaInicial = null;
        // this.fechaFinal=null;


        this.TipoReporte= 0;


        


        

        this.esAreaDeEjecucion = false;     
      },



           /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        


        if (!this.parametros_TipoEstatus.tipoEstatusFirmaId || this.parametros_TipoEstatus.tipoEstatusFirmaId <= 0) 
          return false;


         if (!this.clave_del_codigo_qr || this.clave_del_codigo_qr <= 0) 
          return false;



        
        return true;
      }, 


      


      /**
       * Método encargado de actualizar/cambiar el campo TipoEstatus
       * @param {event.target} datos [datos: nuevo valor del TipoEstatus]
       */
      cambioTipoEstatusFirma(datos){
        this.cambioDeEstatus(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de TipoEstatus
       * @param {int} id [id: identificador del TipoEstatus]
       */
      cambioDeEstatus(id){
        this.parametros_TipoEstatus.tipoEstatusFirmaId = id; 
      },


      esLetra(datos){
        return func.esLetra(datos)
      },

      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Consecutivo'


      ])


    }
  }
</script>
<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
  .btn-buscar{
    background-color: var(--gris-pj);
  }
  </style>



// WEBPACK FOOTER //
// src/components/SIVAC/Comun/FiltroVerificacionReciboDeFirmas.vue